export const Roles = (f?: any) => [
	{
		label: f({
			id: 'vendor',
		}),
		value: 'vendor',
	},
	{
		label: f({
			id: 'expert',
		}),
		value: 'expert',
	},
	{
		label: f({
			id: 'buyer',
		}),
		value: 'buyer',
	},
	{
		label: f({
			id: 'writer',
		}),
		value: 'writer',
	},
	// {
	// 	label: f({
	// 		id: 'vendorExpertiseFirm',
	// 	}),
	// 	value: 'vendor_expertise_firm',
	// },
	// {
	// 	label: f({
	// 		id: 'expertExpertiseFirm',
	// 	}),
	// 	value: 'expert_expertise_firm',
	// },
]

export const RoleVendor = 'vendor'
// export const RoleVendorExpertiseFirm = 'vendor_expertise_firm'
// export const RoleExpertExpertiseFirm = 'expert_expertise_firm'

export const RoleExpert = 'expert'
export const RoleBuyer = 'buyer'
export const RoleWriter = 'writer'

export const isVendor = (currentRole) => currentRole === RoleVendor
export const isExpert = (currentRole) => currentRole === RoleExpert
export const isBuyer = (currentRole) => currentRole === RoleBuyer
export const isWriter = (currentRole) => currentRole === RoleWriter
// export const isVendorExpertiseFirm = (currentRole) => currentRole === RoleVendorExpertiseFirm
// export const isExpertExpertiseFirm = (currentRole) => currentRole === RoleExpertExpertiseFirm


export const isVendorOrExpert = (currentRole) =>
	[RoleExpert, RoleVendor].includes(currentRole)
export const isVendorOrWriter = (currentRole) =>
	[RoleWriter, RoleVendor].includes(currentRole)
export const isVendorOrExpertOrBuyer = (currentRole) =>
	[RoleExpert, RoleVendor, RoleBuyer].includes(currentRole)
export const isVendorOrExpertOrWriter = (currentRole) =>
	[RoleExpert, RoleVendor, RoleWriter].includes(currentRole)
